import { GridItem, Text, Wrap } from "@chakra-ui/react";
import { PlanStatus } from "@syla/shared/types/helpers/subscriptions";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import React, { Fragment } from "react";
import { CancelPlanButton } from "./CancelPlanButton";
import { ChangePlanButton } from "./ChangePlanButton";
import { getPlanDisplayName } from "./getPlanDisplayName";
import { getPlanStatus } from "./getPlanStatus";
import { ManageBillingButton } from "./ManageBillingButton";
import { PlanStatusTag } from "./PlanStatusTag";
import { PurchasePlanButton } from "./PurchasePlanButton";
import { ResumePlanButton } from "./ResumePlanButton";

import { ValueAndButtons } from "./ValueAndButtons";

interface SubscriptionPlanDetailsProps {
  accountId: string;
  canManageSubscription: boolean;
  subscription: SubscriptionWithPlansAndAccess<string> | undefined;
}

export const SubscriptionPlanDetails = ({
  accountId,
  canManageSubscription,
  subscription,
}: SubscriptionPlanDetailsProps) => {
  const planStatus = getPlanStatus(subscription);
  const planName = getPlanDisplayName(subscription);

  return (
    <>
      <GridItem>
        <Text fontWeight="bold">Current plan</Text>
      </GridItem>

      <GridItem>
        <ValueAndButtons>
          <Wrap>
            <Text>{planName}</Text>
            <PlanStatusTag status={planStatus} />
          </Wrap>
          <Wrap>
            {[PlanStatus.None, PlanStatus.Expired].includes(planStatus) && (
              <PurchasePlanButton accountId={accountId} />
            )}

            {planStatus === PlanStatus.Active &&
              canManageSubscription &&
              subscription?.stripeSubscriptionId && (
                <ChangePlanButton
                  accountId={accountId}
                  stripeSubscriptionId={subscription.stripeSubscriptionId}
                />
              )}

            {planStatus === PlanStatus.DowngradeScheduled &&
              canManageSubscription && (
                <ResumePlanButton
                  label={"Undo Downgrade"}
                  accountId={accountId}
                />
              )}

            {planStatus === PlanStatus.RequiresAction && (
              <ManageBillingButton
                accountId={accountId}
                label="Update Billing"
              />
            )}

            {[
              PlanStatus.Active,
              PlanStatus.RequiresAction,
              PlanStatus.DowngradeScheduled,
            ].includes(planStatus) &&
              canManageSubscription &&
              subscription &&
              subscription.stripeSubscriptionId &&
              !subscription.isCancelled && (
                <CancelPlanButton
                  accountId={accountId}
                  stripeSubscriptionId={subscription.stripeSubscriptionId}
                />
              )}

            {planStatus === PlanStatus.Cancelled && canManageSubscription && (
              <ResumePlanButton accountId={accountId} />
            )}
          </Wrap>
        </ValueAndButtons>
      </GridItem>
    </>
  );
};
